<template>
  <!--手机号码已绑定-->
  <div class="validate-phone">
    <!--v-if="developerInfo.phone"-->
    <p class="txt-tip">
      您正在进行重要操作，为保证您的数据安全，请验证您的手机号
    </p>

    <el-form :model="phoneForm" ref="phoneForm" :rules="phoneRules">
      <el-form-item label="手机号">
        <el-input v-model="phoneForm.phone" disabled>{{
          phoneForm.phone
        }}</el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input
          class="input-code"
          v-model="phoneForm.code"
          placeholder="请输入验证码"
        ></el-input>
        <span
          class="btn-get-code btn"
          :class="{ 'btn-forbid': isDisabled }"
          @click="getCode"
          >{{ codeTxt }}</span
        >
      </el-form-item>
    </el-form>
    <div class="btn-confirm btn" @click="submitForm('phoneForm')">确认</div>
  </div>
  <!--手机号码未绑定-->
  <!--
  <div class="validate-phone" v-else>
    <p class="txt-tip" >
      您正在进行重要操作，为保证您的数据安全，请先绑定您的手机号
    </p>

    <el-form :model="phoneForm" ref="phoneForm" :rules="phoneRules" > 
      <el-form-item label="手机号">
        <el-input v-model="phoneForm.phone">
         
        </el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input
          class="input-code"
          v-model="phoneForm.code"
          placeholder="请输入验证码"
        ></el-input>
        <span
          class="btn-get-code btn"
          :class="{ 'btn-forbid': isDisabled }"
          @click="getCode"
          >{{ codeTxt }}</span
        >
      </el-form-item>
    </el-form>
    <div class="btn-confirm btn" @click="submitForm('phoneForm')">确认</div>
  </div>-->
</template>

<script>
import { getVercode, checkVercode, getKfzInfo } from '@/api/common';
import { changePhone } from '@/api/account';
import { mapState } from 'vuex';
export default {
  name: 'phoneForm',
  data() {
    return {
      phoneForm: {
        code: '',
      },
      phoneRules: {
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
      },
      isDisabled: false,
      codeTxt: '获取验证码',
    };
  },
  computed: {
    ...mapState(['developerInfo', 'bankInfo', 'userInfo']),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //判断手机号码是否存在
      if (this.developerInfo.phone) {
        this.phoneForm = {
          phone: this.developerInfo.phone,
          vercode: '',
        };
      } else {
        this.phoneForm = {
          phone: '',
          vercode: '',
        };
      }
    },
    // 获取公共验证码
    async fetchGetVercode() {
      try {
        await getVercode({ phone: this.phoneForm.phone, tk: this.userInfo.tk });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 验证验证码
    async fetchCheckVercode(vercode) {
      try {
        await checkVercode({ vercode });
        if (this.bankInfo.bank_card) {
          //  已绑定去到显示页否则去绑定页
          this.$router.push({ name: 'bindInfo' });
        } else {
          this.$router.push({ name: 'bindForm' });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取验证码
    getCode() {
      this.fetchGetVercode();
    },
    // 存储新手机号
    async fetchKfzInfo() {
      try {
        const res = await getKfzInfo();
        this.$store.commit('SET_DEVELOPER_INFO', res.data);
      } catch (error) {
        console.log(error);
      }
    },
    //绑定手机号码
    async fetchBindPhone() {
      let data = {
        vercode: this.phoneForm.code,
        new_phone: this.phoneForm.phone,
        tk: this.userInfo.tk,
      };
      try {
        await changePhone(data);
        //判断校验是否成立
        this.$message.success('绑定成功');
        this.fetchKfzInfo();
        // this.fetchCheckVercode(this.phoneForm.code)
        this.$router.push({ name: 'bindForm' });
      } catch (error) {
        console.log(error);
      }
    },
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
    // 提交
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.developerInfo.phone
            ? this.fetchCheckVercode(this.phoneForm.code)
            : this.fetchBindPhone();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.el-form-item {
  display: flex;
  margin-bottom: 38px;
  .el-input {
    width: 360px;
    height: 40px;
  }
  ::v-deep .el-form-item__label {
    padding-right: 40px;
    font-size: 16px;
    width: 120px;
  }
}
.validate-phone {
  margin: 0 auto;
  .input-code {
    width: 220px;
    margin-right: 20px;
  }
  .txt-tip {
    margin-bottom: 41px;
    text-align: center;
  }
  .btn-get-code {
    display: inline-block;
    width: 120px;
    height: 32px;
    background: $--color-primary;
    border-radius: 8px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }
  .btn-confirm {
    width: 200px;
    height: 50px;
    color: #ffffff;
    font-size: 20px;
    border-radius: 8px;
    background: $--color-primary;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    margin-top: 73px;
  }
}
.btn {
  cursor: pointer;
  &:hover {
    filter: brightness(105%);
  }
}
.btn-forbid {
  cursor: not-allowed;
  background: #d9d9d9 !important;
  &:hover {
    filter: brightness(100%);
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
</style>
